export default {
  state: {
    token: null,
  },
};
